var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import AboutMeContext from '../about-me-service/AboutMeContext';
import PersonEditor from './PersonEditor';
import useAsync from './UseAsync';
import './styles.css';
import { Button } from '../styleguide/components';
import PhraseContext from '../phrase/PhraseContext';
const getInputFromPerson = (person) => { var _a, _b; return ({ email: ((_a = person === null || person === void 0 ? void 0 : person.email) === null || _a === void 0 ? void 0 : _a.address) || '', phoneNumber: ((_b = person === null || person === void 0 ? void 0 : person.phone) === null || _b === void 0 ? void 0 : _b.number) || '' }); };
// Determine what to show in editor for email and phone. Should it be last known input or whats already stored in person data?
const getEffectiveInput = ({ person, input }) => input ? input : getInputFromPerson(person);
export default () => {
    const { getPerson, updatePerson } = useContext(AboutMeContext);
    // Fetch person and create wrapped/annotated result containing details about server side validation
    // This fetch however can never fail due to validation 
    const wrappedGetPerson = useMemo(() => () => getPerson().then(person => ({ person, errorField: null })), [getPerson]);
    // Update person and create wrapped/annotated result containing details about server side validation
    const wrappedUpdatePerson = useMemo(() => (input, initialPerson) => __awaiter(void 0, void 0, void 0, function* () {
        const { person, errorField } = yield updatePerson(input);
        if (errorField) {
            // validation errors during saving
            // show editor again with previous data and input
            return {
                person: initialPerson,
                errorField,
                input,
            };
        }
        return {
            person,
            errorField: null,
            input: getInputFromPerson(person),
        };
    }), [updatePerson]);
    const inspect = useAsync(wrappedGetPerson);
    const { phrase } = useContext(PhraseContext);
    return inspect({
        pending: () => _jsx(PersonEditor, { onCancel: () => '', onChange: (p) => p }, "pending"),
        resolved: (r, _, update) => _jsx(PersonEditor, { person: r.person, input: getEffectiveInput(r), showEditor: !!r.errorField, errorField: r.errorField, onCancel: () => update(wrappedGetPerson()), onChange: input => update(wrappedUpdatePerson(input, r.person)), onError: e => update(Promise.reject(e)) }, "resolved"),
        rejected: (err, state, update) => (_jsx("div", { children: _jsx(Button, Object.assign({ onClick: () => update(wrappedGetPerson()) }, { children: phrase('application_error', 'Något gick fel, försök igen') })) })),
    });
};
